/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ResponseEntityHistoryList } from '../models/ResponseEntityHistoryList'
import type { TimelineEntityType } from '../models/TimelineEntityType'
import type { TimelineEventType } from '../models/TimelineEventType'

import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'

export class TimelineService {
  /**
   * pobiera historię edycji dowolnego obiektu
   *
   * @returns ResponseEntityHistoryList Historia edycji dowolnego obiektu
   * @throws ApiError
   */
  public static getEntityHistory({
    entityId,
    page,
    limit,
    eventType,
    entityType,
  }: {
    /**
     * identyfikator obiektu
     */
    entityId: number
    /**
     * numer strony do pobrania
     */
    page: number
    /**
     * liczba elementów do pobrania
     */
    limit: number
    /**
     * identyfikator obiektu
     */
    eventType?: Array<TimelineEventType>
    /**
     * identyfikator obiektu
     */
    entityType?: Array<TimelineEntityType>
  }): CancelablePromise<ResponseEntityHistoryList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/timeline/get-history',
      query: {
        entityId: entityId,
        eventType: eventType,
        entityType: entityType,
        page: page,
        limit: limit,
      },
    })
  }
}
